module.exports = __webpack_public_path__ + "img/throw_right.9276b266.gif";